import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-qec-documents-dialogbox',
  templateUrl: './qec-documents-dialogbox.component.html',
  styleUrls: ['./qec-documents-dialogbox.component.scss']
})
export class QecDocumentsDialogboxComponent implements OnInit {
  @Input() visible: any;

  constructor() { }
  @Output() visibleChange = new EventEmitter<boolean>(); // Emits changes

  closeDialog() {
    this.visibleChange.emit(false); // Notify parent that dialog is closed
  }

  ngOnInit(): void {
  }


}
